import React, { useEffect } from "react";
import cn from "classnames";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import Seo from "../../../common/helpers/seo";

import { IStateTree } from "../../store/interfaces";
import { getTeacher } from "../../store/teacher/actions";
import routing from "../../routing";
import PageLoader from "../../components/PageLoader";

import TeacherPage from "./TeacherPage";
import { StyledTeacher } from "./styles";

const Teacher = () => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    let username = pathname.slice(routing.teacher.length + 2);
    const teacher = useSelector(({ teacher }: IStateTree) => teacher);

    useEffect(() => {
        if (username !== teacher?.username) {
            dispatch(getTeacher(pathname));
        }
    }, [])

    if (!teacher || username !== teacher?.username) {
        return <PageLoader />;
    }
    return (
        <StyledTeacher marginTop={50} className={cn("spring--shadow", "spring--padding")} key={teacher._id} style={{ overflow: "visible" }}>
            {teacher.notFound && (
                <>
                    <Seo title={formatMessage({ id: "teacher.teacherNotFound" })} />
                    <div>
                        <FormattedMessage id="teacher.teacherNotFound" />
                    </div>
                </>
            )}
            {teacher.success && (
                <>
                    <Seo title={teacher.displayName || teacher.username} type={"profile"} />
                    <TeacherPage />
                </>
            )}
        </StyledTeacher>
    );
}

export default Teacher;
